import styled from 'styled-components';

import { styledInteraction, styledLayout, styledReset, styledTypography } from '@pkg/primitives';

import { thumbnailOverflowWrapper } from '../Thumbnail/Thumbnail.tokens';

import { type ThumbnailStripSize } from './ThumbnailStrip.types';

import { tokens } from './ThumbnailStrip.tokens';

interface StyledThumbnailStripProps {
    $size?: ThumbnailStripSize;
    $rtl?: boolean;
}

interface ItemProps {
    $pocket?: boolean;
}

export const StyledThumbnailStrip = styled.div<StyledThumbnailStripProps>`
    ${styledReset.borderBox};

    --thumbnail-strip-mask: ${({ $size }) => ($size === 'large' ? tokens.item.mask.large : tokens.item.mask.medium)}px;
    --thumbnail-strip-offset: ${({ $size }) =>
        $size === 'large' ? tokens.item.offset.large : tokens.item.offset.medium}px;
    --thumbnail-strip-radius: ${({ $size }) =>
        $size === 'large' ? tokens.item.radius.large : tokens.item.radius.medium}px;
    --thumbnail-strip-size: ${({ $size }) => ($size === 'large' ? tokens.item.size.large : tokens.item.size.medium)}px;

    --thumbnail-strip-list-direction: ${({ $rtl }) => ($rtl ? 'row-reverse' : 'row')};

    --thumbnail-strip-item-margin: calc(var(--thumbnail-strip-offset) * -1);
    --thumbnail-strip-item-margin-first: ${({ $rtl }) => ($rtl ? 'var(--thumbnail-strip-item-margin)' : 0)};
    --thumbnail-strip-item-margin-last: ${({ $rtl }) => ($rtl ? 0 : 'var(--thumbnail-strip-item-margin)')};

    --thumbnail-strip-pocket-size: ${({ $size }) =>
        $size === 'large' ? tokens.pocket.fontSize.large : tokens.pocket.fontSize.medium}px;
`;

export const List = styled.ol`
    ${styledReset.list};
    display: flex;
    flex-direction: var(--thumbnail-strip-list-direction);
`;

export const StyledItem = styled.li<ItemProps>`
    position: relative;
    z-index: ${tokens.zindex.item};
    flex: 0 0 auto;
    margin-left: calc(var(--thumbnail-strip-offset) * -1);
    width: var(--thumbnail-strip-size);
    height: var(--thumbnail-strip-size);
    border-radius: var(--thumbnail-strip-radius);

    &:first-child {
        margin-left: var(--thumbnail-strip-item-margin-first);
    }

    &:last-child {
        margin-left: var(--thumbnail-strip-item-margin-last);
    }

    &:only-child {
        margin-left: unset;
    }

    &::before {
        ${styledLayout.positionCover({ offset: -1 })};
        ${styledInteraction.interactionDisable};
        z-index: ${tokens.zindex.mask};
        content: '';
        display: block;
        border-radius: var(--thumbnail-strip-radius);
        color: ${({ $pocket }) => ($pocket ? tokens.color.void : tokens.color.coal)};
        box-shadow: inset 0 0 0 var(--thumbnail-strip-mask) currentColor;
    }
`;

export const ThumbnailWrapper = styled.div`
    ${thumbnailOverflowWrapper('var(--thumbnail-strip-radius)')};
    width: 100%;
    height: 100%;
`;

export const StyledPocket = styled.div`
    display: grid;
    place-items: center;
    place-content: center;
    width: 100%;
    height: 100%;
    border-radius: var(--thumbnail-strip-radius);
    background-color: ${tokens.color.void};
    // Needed to stay above the thumbnailOverflowWrapper()
    position: relative;
    z-index: 2;
`;

export const Count = styled.p`
    ${styledTypography.allianceBase};
    font-size: var(--thumbnail-strip-pocket-size);
    font-weight: 600;
    letter-spacing: -0.02em;
`;
